var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("BusinessStockEntryResultView.title")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.reFresh },
                },
                [_vm._v(_vm._s(_vm.$t("refreshText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockEntryResultView.code"),
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.data.code || _vm.noDataText) + " "
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.code },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.receivingLogicWarehouseCode"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.receivingLogicWarehouseCode ||
                              _vm.noDataText
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.receivingLogicWarehouseName"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.receivingLogicWarehouseName ||
                              _vm.noDataText
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.inputTypeMeaning"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.inputTypeMeaning || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.statusMeaning"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.statusMeaning || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.returnsName"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.data.returnsName || _vm.noDataText) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.returnsMobile"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("phoneFilter")(_vm.data.returnsMobile)) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.cptAddress"
                        ),
                      },
                    },
                    [_vm._v(_vm._s(_vm.cptAddress) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.createTimeText") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.data.creationDate || _vm.noDataText) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("BusinessStockEntryResultView.associated"))),
          ]),
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.warehouseWarrantCode"
                        ),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessStockEntryInformView(
                                _vm.data.warehouseWarrantCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.warehouseWarrantCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.warehouseWarrantCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockEntryResultView.orderCode"),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessOrderInternalView(
                                _vm.data.orderCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.orderCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.orderCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockEntryResultView.platformOrderCode"
                        ),
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              return _vm.$toBusinessThirdOrderView(
                                _vm.data.platformOrderCode
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.platformOrderCode))]
                      ),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.platformOrderCode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("BusinessStockEntryResultView.productInformation"))
        ),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "auto-fetch": false,
          serial: _vm.serial,
          selection: false,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "row-key": "id",
          "no-auto-height": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessStockEntryResultView.table.skuName"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessStockEntryResultView.table.skuCode"),
                    prop: "skuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessStockEntryResultView.table.alreadyInputQty"
                    ),
                    prop: "alreadyQty",
                    align: "center",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationLeft",
            fn: function () {
              return [
                _c("span", { staticClass: "ml20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockEntryResultView.alreadyTotalQty")
                    ) +
                      "：" +
                      _vm._s(_vm.data.alreadyQty)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }